import { type Event } from '../../types';

import {
  type AnalyticEvent,
  CatAnalyticsSDK,
} from '@checkatrade/analytics-gateway-sdk';
import { formatEventData } from '../../formatter';

export const initCatAnalytics = ({
  appVersion,
  environment,
}: {
  appVersion: string;
  environment: string;
}) => {
  const catSDK = CatAnalyticsSDK({
    baseUrl: process.env.NEXT_PUBLIC_ANALYTICS_API_URL || '',
    apiKey: process.env.NEXT_PUBLIC_ANALYTICS_API_KEY || '',
    fetcher: fetch,
    appVersion: appVersion || 'unknown-app-version',
    environment: environment || 'unknown-environment',
  });

  return (event: Event) => {
    const formattedEvent = formatEventData(event);
    // TODO Ideally don't cast this - but have a 'legacy event' type within the SDK
    // as the overlap is only the `event_name` mismatch.
    void catSDK.trackEvent(formattedEvent as AnalyticEvent, {
      userId: event.context.userId,
    });
  };
};
